






















import { Vue, Component, Prop } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbAlert, mdbIcon } from '@folky-tools/mdbvue';
import { BankTransferPaymentConfig } from '@/models/common/bank-transfer-payment-config';
import { requiredIf } from 'vuelidate/lib/validators';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbAlert,
        mdbIcon
    },
    validations: {
        bankTransferPaymentConfig: {
            accountNumberToBankTransfer: {
                required: requiredIf(model => {
                    return model.allowBankTransferPayments;
                })
            }
        }
    }
})
export default class EditBankTransferPaymentConfig extends Vue {
    @Prop(BankTransferPaymentConfig) private bankTransferPaymentConfig!: BankTransferPaymentConfig;

    private hasErrors(): boolean {
        this.$v.bankTransferPaymentConfig.$touch();
        if (this.$v.bankTransferPaymentConfig.$error) {
            return true;
        }
        return false;
    }
}
